const quotationChat = {
  quotationChatNavLabel: "Chat disponibile", // translated 
  quotationChatApprovalTitle: "Chat disponibile", // translated 
  quotationChatAccountNotApprovedTitle: "Conto non registrato", // translated 
  quotationChatAccountNotApprovedDescription:
    "Il tuo account non è ancora stato approvato. Contatta il tuo account manager per ulteriori informazioni.", // translated 
  quotationChatViewAiChat: "Visualizza chat I.A.", // translated 

  quotationRequestChatSessions: "Sessione chat", // translated 
  quotationRequestChatNoPastSessions: "Nessuna sessione prevista", // translated 
  quotationRequestChatNewChat: "Nuova chat", // translated 
  quotationRequestChatCloseSidebar: "Sede barra laterale", // translated 
  quotationRequestChatSessionFallback: "Sessione chat", // translated 
  quotationRequestChatDefaultSessionName: "Nuova sessione chat", // translated 
  quotationRequestChatTitle: "Chat visualizzazione", // translated 
  quotationRequestChatResponseLanguageLabel: "Lingua di risposta", // translated 
  quotationRequestChatOpenSidebar: "Apri barra laterale", // translated 
  quotationRequestChatRenameSession: "Rinomina sessione", // translated 
  quotationRequestChatDeleteSession: "Elimina sessione", // translated 
  quotationRequestChatToggleDarkMode: "Attiva/disattiva modalità scura", // translated 
  quotationRequestChatSwitchToLightMode: "Passa alla condizione chiara", // translated 
  quotationRequestChatSwitchToDarkMode: "Passa alla condizione fumo", // translated 
  quotationRequestChatEmptyStateHeading: "Avviare una nuova conversazione di richiesta di preventivo", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Descrivi le tue esigenze di viaggio e creerò una richiesta di preventivo per te.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Digita il tuo messaggio per iniziare una conversazione... (Maiusc+Invio per nuova riga)", // translated 
  quotationRequestChatMessagePlaceholder: "Digita il tuo messaggio... (Maiusc+Invio per nuova riga)", // translated 
  quotationRequestChatUploadFile: "Scarica file", // translated 
  quotationRequestChatUploadAttachment: "Carica collegamento", // translated 

  quotationRequestChatStopGenerating: "Interrompi elementari", // translated 
  quotationRequestChatGenerateQuotation: "Genera risparmi", // translated 
  quotationRequestChatGenerateFinalQuotation: "Generazione di criteri finale", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Finalizza richiesta preventivo", // translated 
  quotationRequestChatHoldToRecord: "Tieni premuto per registrare un messaggio vocale", // translated 
  quotationRequestChatRecordingReleaseToSend: "Registrazione in corso, rilascia per inviare", // translated 
  quotationRequestChatRecording: "individualmente...", // translated 
  quotationRequestChatSelectSessionFirst: "Seleziona prima una sessione di chat.", // translated 
  quotationRequestChatCancelVoiceRecording: "interrompere il commento vocale", // translated 
  quotationRequestChatListening: "In isolamento...", // translated 
  quotationRequestChatTranscribing: "Trascrizione...", // translated 

  quotationRequestChatFileUploadedSuccess: "File caricato con successo.", // translated 
  quotationRequestChatUnsupportedFileType: "Tipo di file non supportato. Carica un PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), testo/CSV o un’immagine.", // translated
  quotationRequestChatFailedCreateSession: "Impossibile creare la sessione di chat. Riprova.", // translated 
  quotationRequestChatFailedUploadFile: "Impossibile caricare il file. Riprova.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Rispondi alle domande in sospeso prima di inviare un altro messaggio.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Rispondi alle domande in sospeso prima di finalizzare la richiesta di preventivo.", // translated 
  quotationRequestChatFavoriteMarked: "Sessione chat aggiunta ai preferiti", // translated 
  quotationRequestChatFavoriteUnmarked: "Sessione chat rimossa dai preferiti", // translated 
  quotationRequestChatFailedSetFavorite: "Impossibile aggiungere ai preferiti", // translated 
  quotationRequestChatFailedUnsetFavorite: "Impossibile rimuovere dai preferiti", // translated 
  quotationRequestChatRenamedSuccess: "Sessione chat rinominata con successo.", // translated 
  quotationRequestChatFailedRename: "Impossibile rinominare la sessione di chat. Riprova.", // translated 
  quotationRequestChatDeletedSuccess: "Sessione chat eliminata con successo.", // translated 
  quotationRequestChatFailedDelete: "Impossibile eliminare la sessione chat. Riprova.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Allegato eliminato con successo.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Impossibile eliminare l'allegato. Riprova.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Richiesta di preventivo inviata con successo! La tua richiesta è in elaborazione.", // translated 
  quotationRequestChatFailedSubmit: "Impossibile inviare la richiesta di preventivo", // translated 
  quotationChatPdfDownloadedSuccess: "PDF Scaricato con successo!", // translated 
  quotationChatFailedGeneratePdf: "Impossibile generare il PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Seleziona un utente sub-agente prima di inviare la richiesta di preventivo.", // translated 
  quotationRequestChatAppUserLoading:
    "Il profilo utente dell'app CRM è ancora in caricamento. Riprova tra un momento.", // translated 
  quotationRequestChatAppUserMismatch:
    "Il profilo utente dell'app CRM non corrisponde a questa sessione di chat.", // translated 

  quotationRequestChatRenameTitle: "Rinomina sessione chat", // translated 
  quotationRequestChatSessionName: "Nome sessione", // translated 
  quotationRequestChatEnterSessionName: "Inserire nome sessione", // translated 
  quotationRequestChatSaving: "Salvaggio...", // translated 
  quotationRequestChatSave: "Sal", // translated 
  quotationRequestChatDeleteTitle: "Chat completa sessioni", // translated 
  quotationRequestChatDeleteConfirm: "Sei sicuro di voler eliminare questa sessione di chat?", // translated 
  quotationRequestChatDeleteCannotUndo: "Questa azione non può essere annullata.", // translated 
  quotationRequestChatDeleting: "Eliminazione...", // translated 
  quotationRequestChatDelete: "Elimina", // translated 

  quotationRequestChatAttachmentsTitle: "Allegati chat richiesta preventivo", // translated 
  quotationRequestChatLoadingAttachments: "Fatto accusa...", // translated 
  quotationRequestChatNoAttachments: "Nessun collegamento trovato", // translated 
  quotationRequestChatDeleteAttachment: "Elimina l'allegato", // translated 
  quotationRequestChatUploadingAttachment: "Caricamento allegati...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Attendi mentre il file viene caricato.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Rispondi alle domande in sospeso", // translated 
  quotationRequestChatProposeOwnAnswer: "Proponi la mia attenzione", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Digita la tua risposta...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{risposta}} di {{totale}} risposte", // translated 
  quotationRequestChatReadyToSubmit: "Pronto per l'ultimo", // translated 
  quotationRequestChatSubmitAll: "Invia il tuo", // translated 
  quotationRequestChatRespondToOneQuestion: "Rispondi a {{count}} domanda", // translated 
  quotationRequestChatRespondToManyQuestions: "Rispondi a {{count}} domande", // translated 

  quotationRequestChatFinalizeTitle: "Finalizza richiesta preventivo", // translated 
  quotationRequestChatLoadingSessionData: "Caricamento dati sessione...", // translated 
  quotationRequestChatErrorLoadingSession: "Errore nel caricamento dei dati di sessione. Riprova.", // translated 
  quotationRequestChatQuotationTitle: "Titolo calcolatore", // translated 
  quotationRequestChatExtraComments: "Contributo aggiuntivo", // translated 
  quotationRequestChatSubmitting: "Invio...", // translated 
  quotationRequestChatSubmit: "Invia", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Invio informazioni preventivo...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Attendi mentre la richiesta di preventivo viene inviata.", // translated 

  quotationRequestChatSelectSubagent: "Seleziona sub-agente", // translated 
  quotationRequestChatSearchSubagents: "Cerca sub-agenti...", // translated 
  quotationRequestChatLoadingSubagents: "Caricamento sub-agente...", // translated 
  quotationRequestChatNoSubagentsFound: "Nessun sub-agente trovato", // translated 
  quotationRequestChatNoSubagentsAvailable: "Nessun sub-agente disponibile", // translated 
  quotationRequestChatSelectedSubagent: "Selezionato: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Inglese sub-agente", // translated 
  quotationRequestChatSearchUsers: "Cerca utenti...", // translated 
  quotationRequestChatNoUsersFound: "Nessun utente trovato", // translated 
  quotationRequestChatNoUsersAvailable: "Nessun utente disponibile", // translated 

  quotationChatDownloadSummaryTitle: "Scarica il riepilogo del preventivo", // translated 
  quotationChatDownloadSummaryDescription:
    "Compila i tuoi dati qui sotto per generare un riepilogo PDF personalizzato del preventivo di viaggio. Il PDF includerà tutti i dettagli del viaggio, le destinazioni, le informazioni sui trasporti e l'itinerario giorno per giorno.", // translated 
  quotationChatCustomerTitle: "Si", // translated 
  quotationChatSelectTitle: "Indicare marchio", // translated 
  quotationChatHonorificMr: "Sig.", // translated 
  quotationChatHonorificMrs: "Sig.ra", // translated 
  quotationChatHonorificMs: "Sig.ra", // translated 
  quotationChatHonorificDr: "Dott.", // translated 
  quotationChatHonorificProf: "Prof.", // translated 
  quotationChatCustomerPhone: "Telefono", // translated 
  quotationChatCustomerCompany: "Azienda", // translated 
  quotationChatCustomerMessage: "Significato", // translated 
  quotationChatCustomerCountry: "Titolo", // translated 
  quotationChatGenerating: "Generazione...", // translated 
  quotationChatDownloadPdf: "Scarica PDF", // translated 

  quotationChatTripSummary: "Riepilogo viaggio", // translated 
  quotationChatDownloadAsPdf: "Scarica come PDF", // translated 
  quotationChatNoTripSummary: "Nessun riepilogo viaggio disponibile per questa sessione.", // translated 

  quotationRequestChatThinking: "Smetti di pensare...", // translated 
  quotationRequestChatSources: "Fonti", // translated 
  quotationRequestChatSearchingWebFor: 'Ricerca sul web per: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Servizi eseguiti dal tour operator", // translated 
  quotationRequestChatServicesByCustomer: "Servizi gestiti dal Cliente", // translated 
  quotationRequestChatReadyNotice:
    "Ora puoi generare un preventivo per questa richiesta cliccando il pulsante a destra.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Generazione di criteri finale", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Forse desideri chiedere:", // translated 
  quotationRequestChatClickToSendSuggestion: "Clicca per inviare questo messaggio", // translated 

  quotationRequestChatAddToFavorites: "Seleziona ai preferiti", // translated 
  quotationRequestChatRemoveFromFavorites: "Rimuovi dai preferiti", // translated 
  quotationRequestChatSubmitted: "Inviato", // translated 

  quotationRequestChatQuotationRequest: "Richiesta preventivo: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{titolo}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Stato: {{status}}", // translated 

  quotationChatLoading: "Diritto...", // translated 
  quotationChatSessionNotFound: "Sessione chat non trovata per questo preventivo", // translated 
  quotationChatMemberSessionNotFound: "Sessione membro non trovata per il tuo account", // translated 
  quotationChatUnableToConnect: "Impossibile connettersi alla chat", // translated 
  quotationChatConnecting: "Comunicazione...", // translated 
  quotationChatTypeYourMessage: "digita il tuo messaggio...", // translated 
  quotationChatConnected: "Connesso", // translated 
  quotationChatConnectingStatus: "Comunicazione...", // translated 
  quotationChatDisconnected: "Disco connesso", // translated 
};


export default quotationChat;
